import { Button, Flex, Text } from '@mantine/core';
import { useTranslationOrganization } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';

interface Props {
	canEdit: boolean;
	onStart: () => void;
}

export const ProgrammeDefaultsEmptyState = ({ canEdit, onStart }: Props) => {
	const tOrganization = useTranslationOrganization();

	return (
		<Flex direction="column" align="flex-start" gap="1rem" p="1rem">
			<Text size="B6" c="dark.3">
				{tOrganization('programme_defaults.empty_state.description')}
			</Text>
			{canEdit && (
				<Button onClick={onStart}>
					{tOrganization('programme_defaults.empty_state.button')}
				</Button>
			)}
		</Flex>
	);
};
